import * as React from "react";
import { Button, FormGroup, Input, Label, Modal } from "../components/Modal";
import { TrimFields } from "../general/HttpClient";
import * as UserStore from "./UserStore";

interface UserFormModalProps {
    mode: "create" | "edit";
    isOpen: boolean;
    user?: any;
    organizationId: string;
    onClose: () => void;
    onSaved: () => void;
}

export const UserFormModal = ({ mode, isOpen, user, organizationId, onClose, onSaved }: UserFormModalProps) => {
    const [email, setEmail] = React.useState("");
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [membershipType, setMembershipType] = React.useState(0);
    const [error, setError] = React.useState("");
    const [isSaving, setIsSaving] = React.useState(false);

    React.useEffect(() => {
        if (!isOpen) return;
        setEmail(mode === "edit" ? user?.email || "" : "");
        setFirstName(mode === "edit" ? user?.firstName || "" : "");
        setLastName(mode === "edit" ? user?.lastName || "" : "");
        setPhoneNumber(mode === "edit" ? user?.phoneNumber || "" : "");
        setMembershipType(0);
        setError("");
        setIsSaving(false);
    }, [isOpen, mode, user?.id]);

    const save = () => {
        setIsSaving(true);
        setError("");

        const request = mode === "create"
            ? UserStore.CreateUser(TrimFields({ email, firstName, lastName, phoneNumber, membershipType, organization: organizationId } as UserStore.CreateIdentityUserRequest))
            : UserStore.UpdateUser(TrimFields({ id: user.id, email, firstName, lastName, phoneNumber } as UserStore.UserUpdateModel));

        request
            .then(() => {
                onSaved();
                onClose();
            })
            .catch((response) => setError(response.response?.data?.message || response.response?.data || `Unable to ${mode} user.`))
            .finally(() => setIsSaving(false));
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={!isSaving} title={mode === "create" ? "Create New User" : "Update User"} icon={["fad", mode === "create" ? "user-plus" : "edit"]} iconColor={mode === "create" ? "text-green-600" : "text-blue-600"}>
            <div className="p-6 space-y-4">
                <FormGroup><Label>Email address</Label><Input type="email" value={email} onChange={(event: any) => setEmail(event.target.value)} placeholder="user@example.com" /></FormGroup>
                <FormGroup><Label>First name</Label><Input value={firstName} onChange={(event: any) => setFirstName(event.target.value)} /></FormGroup>
                <FormGroup><Label>Last name</Label><Input value={lastName} onChange={(event: any) => setLastName(event.target.value)} /></FormGroup>
                <FormGroup><Label>Phone number</Label><Input type="tel" value={phoneNumber} onChange={(event: any) => setPhoneNumber(event.target.value)} /></FormGroup>
                {mode === "create" && <FormGroup>
                    <Label>User type</Label>
                    <Input type="select" value={membershipType} onChange={(event: any) => setMembershipType(Number(event.target.value))}>
                        <option value="0">Staff</option><option value="1">Student</option><option value="2">Parent</option><option value="3">Guest</option>
                    </Input>
                </FormGroup>}
                {error && <div className="bg-red-50 border border-red-200 rounded-md p-3 text-sm text-red-800">{String(error)}</div>}
            </div>
            <div className="border-t border-gray-200 bg-gray-50 px-6 py-4 flex justify-end space-x-3">
                <Button variant="secondary" onClick={onClose} disabled={isSaving}>Cancel</Button>
                <Button onClick={save} disabled={!email.trim() || isSaving}>{isSaving ? "Saving…" : mode === "create" ? "Create user" : "Update user"}</Button>
            </div>
        </Modal>
    );
};
